import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Pie, Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
);

function GraphHtmlRenderer({ html, idx }) {
    const [chartData, setChartData] = React.useState(null);
    const [chartType, setChartType] = React.useState('bar');

    React.useEffect(() => {
        if (!html) return;

        console.log('HTML received:', html.substring(0, 500)); // Debug log

        try {
            // Find the complete JSON array by counting brackets
            const startMatch = html.match(/Plotly\.newPlot\([^,]+,\s*/);
            if (!startMatch) return;

            const startIndex = startMatch.index + startMatch[0].length;
            let bracketCount = 0;
            let endIndex = startIndex;

            // Find the complete JSON array
            for (let i = startIndex; i < html.length; i++) {
                if (html[i] === '[') bracketCount++;
                if (html[i] === ']') bracketCount--;
                if (bracketCount === 0 && html[i] === ']') {
                    endIndex = i + 1;
                    break;
                }
            }

            const jsonStr = html.substring(startIndex, endIndex);
            const plotlyData = JSON.parse(jsonStr);
            processPlotlyData(plotlyData);

        } catch (error) {
            console.error('Error parsing Plotly data:', error);
        }
    }, [html]);

    const processPlotlyData = (plotlyData) => {
        if (plotlyData.length > 0) {
            const trace = plotlyData[0];
            console.log('Trace data:', trace);

            const isPieChart = trace.type === 'pie';

            if (isPieChart) {
                setChartType('pie');
                setChartData({
                    labels: trace.labels || trace.x,
                    datasets: [{
                        data: trace.values || trace.y,
                        backgroundColor: [
                            '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0',
                            '#9966FF', '#FF9F40', '#FF6384', '#C9CBCF'
                        ]
                    }]
                });
            } else {
                setChartType('bar');
                setChartData({
                    labels: trace.x || [],
                    datasets: [{
                        label: trace.name || 'Data',
                        data: trace.y || [],
                        backgroundColor: '#36A2EB'
                    }]
                });
            }
        }
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            }
        }
    };

    if (!chartData) {
        return (
            <div style={{ padding: '20px' }}>
                <div>Loading chart...</div>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
                    Debug: HTML length: {html?.length || 0}
                </div>
            </div>
        );
    }

    return (
        <div style={{ width: "100%", height: "400px", padding: "20px" }}>
            {chartType === 'pie' ? (
                <Pie data={chartData} options={chartOptions} />
            ) : (
                <Bar data={chartData} options={chartOptions} />
            )}
        </div>
    );
}

export default GraphHtmlRenderer;